import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useIntl } from "react-intl";
//
import Box from "@mui/material/Box";
// component, hooks
import AccordionMain from "../../../../../../../common/components/accordion/AccordionMain";
import AccordionDetailChildren from "./AccordionDetailChildren";
// store
// config,utils
// style

const PublicDataset = () => {
  // props
  // route,intl
  const intl = useIntl();
  // store
  // local state
  // hooks

  return (
    <Box>
      <AccordionMain
        accordionProps={{}}
        darkMode
        summaryChildren={{
          text: intl.formatMessage({
            id: "sna.sidebar.filetool.group.publicdataset",
            defaultMessage: "公共",
          }),
        }}
        detailsChildren={<AccordionDetailChildren />}
        detailsProps={{}}
      />
    </Box>
  );
};

PublicDataset.propTypes = {};

PublicDataset.defaultProps = {};

export default PublicDataset;
